import React, { useState } from 'react';
import {useSelector} from 'react-redux';
import firebase from '../../config/firebase';
import './docs-register.css';
import Navbar from '../../components/navbar';
import 'animate.css'

function DocsRegister(){  
    const [carregando, setCarregando] = useState();
    const [msgTipo, setMsgTipo] = useState();
    const [idEmail, setIdEmail] = useState();
    const [tipo, setTipo] = useState();
    const [nome, setNome] = useState();
    const [year, setYear] = useState();
    const [cpf, setCpf] = useState();
    const [data, setData] = useState();
    const [file, setFile] = useState();
    const usuarioEmail = useSelector(state => state.usuarioEmail);


    const storage = firebase.storage();
    const db = firebase.firestore();


    function cadastrar(){
        setMsgTipo(null);
        setCarregando(1)
        storage.ref(`PDF/${file.name}`).put(file).then(()=>{
            db.collection('db-app').add({
                email: idEmail,
                tipo: tipo,
                nome: nome,
                cpf: cpf,
                data: data,
                year: year,
                usuario: usuarioEmail,
                pdf: file.name,
                publico: 1
            }).then(() => {
                setMsgTipo('sucesso')
                setCarregando(0)
            }).catch(erro => {
                setMsgTipo('erro')
                setCarregando(0)
            });
    });
}
    
    return(
        <>
        <div className="form-register">

            <form className="inner-form animate__animated animate__pulse">
                <h3 className="mx-auto font-height-bold comp">Registro de documento</h3>
                <div className="form-floating mt-4">
                    <input onChange={(e) => setIdEmail(e.target.value)} type="text" id="floatingInput form-required" className="form-control" placeholder="0"/>
                    <label for="floatingInput">E-mail</label>
                </div>
                <div className="form-floating mt-4">
                    <input onChange={(e) => setNome(e?.target.value)} type="text" className="form-control form-required" id="floatingInput" placeholder="0"/>
                    <label for="floatingInput">Nome</label>
                </div>
                <div className="form-floating mt-4">
                    <input  onChange={(e) => setCpf(e.target.value)} type="text" className="form-control form-required" id="floatingInput" placeholder="0"/>
                    <label for="floatingInput">CPF ou CNPJ</label>
                </div>
                <div className="data">
                    <div className="form mt-4">
                        <select className="form-select form-required"  aria-label="Data do documento" onChange={(e) => setData(e.target.value) } value={data && data}>
                            <option disabled selected>Selecione o Mês</option>
                            <option value="Janeiro">Janeiro</option>
                            <option value="Fevereiro">Fevereiro</option>
                            <option value="Março">Março</option>
                            <option value="Abril">Abril</option>
                            <option value="Maio">Maio</option>
                            <option value="Junho">Junho</option>
                            <option value="Julho">Julho</option>
                            <option value="Agosto">Agosto</option>
                            <option value="Setembro">Setembro</option>
                            <option value="Outubro">Outubro</option>
                            <option value="Novembro">Novembro</option>
                            <option value="Dezembro">Dezembro</option>
                        </select>
                    </div>
                    <div className="form-floating mt-4">
                        <input  onChange={(e) => setYear(e.target.value)} type="text" className="form-control form-required" id="floatingInput" placeholder="0"/>
                        <label for="floatingInput">Ano do documento</label>
                    </div>
                </div>
                <div className="form mt-4">
                    <select className="form-select form-required"  aria-label="Selecione o tipo de documento" onChange={(e) => setTipo(e.target.value) } value={tipo && tipo}>
                        <option disabled selected>Tipo de documento</option>
                        <option value="Contracheque">Contracheque</option>
                        <option value="Férias">Férias</option>
                        <option value="Termo de rescisão">Termo de rescisão</option>
                        <option value="Contrato">Contrato</option>
                        <option value="Controle de ronda">Controle de ronda</option>
                    </select>
                </div>
                <div className="form mt-4">
                <label for="file-upload" className="file-upload">
                    Upload arquivo
                </label>
                    <input  className="form-required" onChange={(e) => setFile(e.target.files[0])} type="file" id="file-upload" />
                </div>
                <div className="">
                    {
                        carregando > 0 ? <div className="spinner-border text-danger mt-4" role="status"><span className="sr-only"></span></div>
                        : <button onClick={cadastrar} className="w-100 btn btn-lg btn-custom mt-4" type="submit">Enviar documento</button>                       

                    }
                </div>
                <div className="mensagem-aviso form-group mt-4">
                    {msgTipo === 'sucesso' && <span className="msg-success">Documento registrado com sucesso</span>}
                    {msgTipo === 'erro' && <span className="msg-error">Falha ao registrar documento</span>}
                </div>

            </form>
        </div>
        <Navbar />
        </>
    )
}

export default DocsRegister